import type { z } from "zod"
import type { orderSchema } from "./zod/schema"

type Order = z.infer<typeof orderSchema>

const multiplyBasisPoints = (price: number, basisPoints: number) =>
  price * (basisPoints / 10_000)

function calculateOrderTotal(order: Order) {
  const price = (order.price || 0) * order.quantity
  const appliedCreatorFee =
    order.applyCreatorFee || order.isCreatorFeeRequired
      ? multiplyBasisPoints(price, order.creatorFeeBasisPoints)
      : 0
  const openseaFee = multiplyBasisPoints(price, order.openSeaFeeBasisPoints)

  return {
    withoutFees: price,
    afterFees: price - appliedCreatorFee - openseaFee,
    adjustedForFees: price + appliedCreatorFee + openseaFee,
    creatorFee: multiplyBasisPoints(price, order.creatorFeeBasisPoints),
    openseaFee,
  }
}

export function calculateOrderTotals(orders: Order[]) {
  const totals = orders.reduce(
    (acc, order) => {
      const {
        withoutFees,
        afterFees,
        adjustedForFees,
        creatorFee,
        openseaFee,
      } = calculateOrderTotal(order)

      return {
        withoutFees: acc.withoutFees + withoutFees,
        afterFees: acc.afterFees + afterFees,
        adjustedForFees: acc.adjustedForFees + adjustedForFees,
        creatorFee: acc.creatorFee + creatorFee,
        openseaFee: acc.openseaFee + openseaFee,
      }
    },
    {
      withoutFees: 0,
      afterFees: 0,
      adjustedForFees: 0,
      creatorFee: 0,
      openseaFee: 0,
    },
  )

  return totals
}
